var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated-process-indicator"},[_c('AnimatedGearIcon',{staticClass:"animated-process-indicator__icon"}),_vm._v(" "),_c('h4',{staticClass:"animated-process-indicator__heading"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }